/**
 * Manages the "Made in USA" image overlay for Rio Gallery (Variant Image Wizard)
 * Overlay is positioned on the first/main image and shows/hides based on variant metafield and active slide
 */
(function() {
  'use strict';

  let overlay = null;
  let marketHandle = null;
  let variantPicker = null;
  let madeInUsaVariantIds = [];
  let slideObserver = null;
  let rioGallery = null;
  let currentSlideContainer = null;

  function init() {
    const productMedia = document.querySelector('#product-media');
    if (!productMedia) {
      setTimeout(init, 200);
      return;
    }

    const imageUrl = productMedia.dataset.madeInUsaImage;
    marketHandle = productMedia.dataset.marketHandle;
    const variantIdsStr = productMedia.dataset.madeInUsaVariantIds;
    
    if (variantIdsStr) {
      madeInUsaVariantIds = variantIdsStr.split(',').map(id => id.toString());
    }
    
    if (!imageUrl) return; // No image configured

    // Wait for Rio gallery to be available
    function waitForGallery() {
      rioGallery = document.querySelector('.rio-media-gallery');
      if (!rioGallery) {
        setTimeout(waitForGallery, 200);
        return;
      }

      // Create overlay
      overlay = document.querySelector('.made-in-usa-image-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'made-in-usa-image-overlay';
        overlay.style.cssText = 'pointer-events: none; display: none; position: absolute;';
        
        const img = document.createElement('img');
        img.src = imageUrl;
        img.alt = 'Made in USA';
        img.className = 'made-in-usa-image-overlay__img';
        overlay.appendChild(img);
      }

      // Position overlay in the active slide
      positionOverlay();

      setupVariantPicker();
      setupSlideObserver();
    }

    waitForGallery();
  }

  /**
   * Positions the overlay in the active slide container
   */
  function positionOverlay() {
    if (!rioGallery || !overlay) return;

    // Find the active slide
    const activeSlide = rioGallery.querySelector('.pwzrswiper-slide-active');
    if (!activeSlide) return;

    // Find the image container within the slide (look for img parent)
    const slideImage = activeSlide.querySelector('img');
    if (!slideImage) return;

    // Find a suitable container (img's parent that has positioning context)
    let container = slideImage.parentElement;
    while (container && container !== activeSlide) {
      const style = window.getComputedStyle(container);
      if (style.position === 'relative' || style.position === 'absolute' || container === activeSlide) {
        break;
      }
      container = container.parentElement;
    }

    // Use activeSlide if no positioned container found, or ensure activeSlide is positioned
    if (!container || container === activeSlide) {
      container = activeSlide;
      const style = window.getComputedStyle(container);
      if (style.position === 'static') {
        container.style.position = 'relative';
      }
    }

    // Move overlay if container changed
    if (currentSlideContainer !== container) {
      if (overlay.parentElement) {
        overlay.parentElement.removeChild(overlay);
      }
      container.appendChild(overlay);
      currentSlideContainer = container;
    }
  }

  /**
   * Checks if the first main slide is currently active
   */
  function isFirstSlideActive() {
    if (!rioGallery) return true;

    const mainSlides = rioGallery.querySelectorAll('.pwzrswiper-slide');
    if (mainSlides.length === 0) return true;

    return mainSlides[0].classList.contains('pwzrswiper-slide-active');
  }

  function updateOverlay(variant) {
    if (!overlay) return;

    // Reposition overlay if slide changed
    positionOverlay();

    // Check market handle first (only show on US market)
    if (marketHandle !== 'us') {
      overlay.style.display = 'none';
      return;
    }

    // Get variant if not provided
    if (!variant && variantPicker) {
      variant = variantPicker.variant;
    }

    if (!variant || !variant.id) {
      overlay.style.display = 'none';
      return;
    }

    // Check if variant ID is in the made in USA list
    const variantIdStr = variant.id.toString();
    const hasMadeInUsa = madeInUsaVariantIds.includes(variantIdStr);

    // Check if first slide is active
    const isFirst = isFirstSlideActive();

    // Show overlay only if variant has madeinusa metafield AND first slide is active
    overlay.style.display = (hasMadeInUsa && isFirst) ? 'block' : 'none';
  }

  /**
   * Sets up MutationObserver to watch for slide changes
   */
  function setupSlideObserver() {
    if (!rioGallery) return;

    // Observe the gallery for class changes on slides
    if (slideObserver) slideObserver.disconnect();
    
    slideObserver = new MutationObserver(() => {
      // Reposition overlay when slides change
      positionOverlay();
      // Update overlay visibility
      if (variantPicker && variantPicker.variant) {
        updateOverlay();
      }
    });

    // Observe class changes on slide elements
    const mainSlides = rioGallery.querySelectorAll('.pwzrswiper-slide');
    mainSlides.forEach(slide => {
      slideObserver.observe(slide, {
        attributes: true,
        attributeFilter: ['class']
      });
    });
  }

  function setupVariantPicker() {
    variantPicker = document.querySelector('variant-picker');
    if (!variantPicker) {
      setTimeout(setupVariantPicker, 200);
      return;
    }

    // Wait for variant picker data to be ready
    function waitForVariantData() {
      if (variantPicker.data && variantPicker.data.formatted) {
        // Data is ready, set up listener
        variantPicker.addEventListener('on:variant:change', (evt) => {
          updateOverlay(evt.detail?.variant);
        });

        // Initial update after a short delay
        setTimeout(() => updateOverlay(), 500);
      } else {
        // Data not ready yet, wait a bit more (max 10 seconds)
        const attempts = waitForVariantData.attempts || 0;
        if (attempts < 50) {
          waitForVariantData.attempts = attempts + 1;
          setTimeout(waitForVariantData, 200);
        }
      }
    }

    waitForVariantData();
  }

  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }
})();
